import { Grid } from "@mui/material";
import React from "react";
import CiedDeviceInformationPreviewItem from "../preview/CiedDeviceInformationPreviewItem";
import PreviousDevicesPreviewModal from "../preview/PreviousDevicesPreviewModal";

const PreviousPrimaryDeviceInformationPreview = ({ previousDevices }) => {
  return (
    <Grid container columnSpacing={3} className="view-pdf__drawer-grid">
      {previousDevices && previousDevices?.length > 0 && (
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          item
          style={{ margin: "15px 0 5px" }}
        >
          <Grid item>
            <div className="device-info__device-title">
              PREVIOUS PRIMARY DEVICES
            </div>
          </Grid>
          <Grid item>
            {previousDevices?.length > 3 && (
              <PreviousDevicesPreviewModal previousDevices={previousDevices} />
            )}
          </Grid>
        </Grid>
      )}

      {previousDevices &&
        previousDevices?.length > 0 &&
        previousDevices?.slice(0, 3)?.map((previousDevice, index) => (
          <CiedDeviceInformationPreviewItem
            key={index}
            deviceInformation={{
              ...previousDevice,
              modelName: previousDevice?.device_model,
              modelNumber: previousDevice?.device_serial,
              mriCompatible: false,
              alertDeviceText: "",
            }}
            isPreviousDevices={true}
          />
        ))}
    </Grid>
  );
};

export default PreviousPrimaryDeviceInformationPreview;
